export default __webpack_public_path__ + "static/media/elephant.b751c5cf.ogg";